define.alias("shared/components/shared/ui/dynamic-social-set", "calendar/components/shared/ui/dynamic-social-set");